// DOM helper functions
export function el(tag: string, attrs?: Record<string, string>, ...children: (HTMLElement | string)[]): HTMLElement {
  const elem = document.createElement(tag);
  if (attrs) {
    Object.entries(attrs).forEach(([k, v]) => {
      if (k === 'class') {
        elem.className = v;
      } else if (k === 'data-*') {
        // Handle data attributes
      } else {
        elem.setAttribute(k, v);
      }
    });
  }
  children.forEach(child => {
    if (typeof child === 'string') {
      elem.appendChild(document.createTextNode(child));
    } else {
      elem.appendChild(child);
    }
  });
  return elem;
}

export function setText(element: HTMLElement, text: string): void {
  element.textContent = text;
}

export function setHTML(element: HTMLElement, html: string): void {
  element.innerHTML = html;
}

export function addClass(element: HTMLElement, className: string): void {
  element.classList.add(...className.split(' '));
}

export function removeClass(element: HTMLElement, className: string): void {
  element.classList.remove(...className.split(' '));
}

export function toggleClass(element: HTMLElement, className: string, force?: boolean): boolean {
  return element.classList.toggle(className, force);
}

export function hasClass(element: HTMLElement, className: string): boolean {
  return element.classList.contains(className);
}

export function on(
  element: HTMLElement,
  event: string,
  handler: EventListener,
  options?: AddEventListenerOptions
): () => void {
  element.addEventListener(event, handler, options);
  return () => element.removeEventListener(event, handler);
}

export function query(selector: string, parent?: HTMLElement): HTMLElement | null {
  return (parent || document).querySelector(selector);
}

export function queryAll(selector: string, parent?: HTMLElement): HTMLElement[] {
  return Array.from((parent || document).querySelectorAll(selector));
}

export function show(element: HTMLElement): void {
  element.classList.remove('hidden');
}

export function hide(element: HTMLElement): void {
  element.classList.add('hidden');
}

export function isHidden(element: HTMLElement): boolean {
  return element.classList.contains('hidden');
}
